/**
 * Portrait bottom bar: the create-and-show loop only — New, Stories, Preview,
 * Share — plus a More sheet for everything else. Buttons are WCAG AAA: 48px
 * targets, 7:1 text contrast on the lavender bar, focus-visible rings.
 * @module NavigationControlBarPortrait
 * @category Display Components
 */
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { text } from "@quickpoint.me/shared";
import { LocaleAtom } from "../state/localeAtom";
import MobilePreview from "./controls/MobilePreviewControl";
import MoreControl from "./controls/MoreControl";
import ShareControl from "./controls/ShareControl";
import StacksControl from "./controls/StacksControl";

const StyledControlBar = styled.nav`
    align-items: stretch;
    height: 100%;
    width: 100%;
    grid-area: navigation-portrait;
    display: flex;
    gap: 0.4rem;
    padding: 0.4rem;
    background-color: ${(props) => props.theme.navigationBackGround};
    border-top: 1px solid ${(props) => props.theme.navigationFrame};

    /* equal-width slots with visible edges; the border grey is ≥3:1 against
       both the white fill and the lavender bar (WCAG 1.4.11) */
    > button {
      flex: 1 1 0;
      min-width: 44px;
      min-height: 48px;
      height: 100%;
      margin: 0;
      padding: 0 0.25rem;
      font-size: 0.85rem;
      background: #fff;
      border: 1.5px solid #6E6A7A;
      border-radius: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    /* Presentations is the long button — creating happens inside its panel
       (NewStoryButton in the StacksHeader), so it absorbs the old New slot */
    > button#control-stories {
      flex: 1.8 1 0;
    }
`;

function NavigationControlBarPortrait() {
  useRecoilValue(LocaleAtom); // re-render on locale change

  return (
    <StyledControlBar
      className="styled-NavigationControlBarPortrait"
      aria-label={text.ui.mainNavigation}
    >
      <StacksControl />
      <MobilePreview />
      <ShareControl />
      <MoreControl />
    </StyledControlBar>
  );
}

export { NavigationControlBarPortrait };
